import {
  Type,
  Mail,
  Phone,
  AlignLeft,
  List,
  CheckSquare,
  Circle,
  Calendar,
  Upload,
  Hash,
  Link,
  Heading,
  FileText,
  Sparkles,
  PartyPopper,
  SlidersHorizontal,
  BarChart3,
  Star,
  Image,
  ToggleLeft,
  MessageSquare,
  ExternalLink,
  type LucideIcon,
} from 'lucide-react';
import type { FieldType } from '@/types/forms';

/**
 * Canonical FieldType → Lucide icon mapping.
 *
 * Source of truth for field iconography across the app.
 * Consumers (kept in sync via Record exhaustiveness):
 *   - components/forms/editor/mobile/atoms/FieldTypeIcon.tsx (wrapper atom)
 *   - components/forms/editor/mobile/atoms/SlideStripItem.tsx (via FieldTypeIcon)
 *   - components/forms/MarkdownImporter.tsx (preview list)
 *   - components/forms/FlowNode.tsx (currently uses local FIELD_ICON_MAP — future refactor)
 *
 * Adding a new FieldType to the union will trigger a TS error here until registered.
 */
export const FIELD_ICONS: Record<FieldType, LucideIcon> = {
  text: Type,
  email: Mail,
  phone: Phone,
  textarea: AlignLeft,
  select: List,
  multiselect: List,
  checkbox: CheckSquare,
  radio: Circle,
  date: Calendar,
  datetime: Calendar,
  time: Calendar,
  file: Upload,
  number: Hash,
  url: Link,
  heading: Heading,
  paragraph: FileText,
  welcome_screen: Sparkles,
  thank_you_screen: PartyPopper,
  opinion_scale: SlidersHorizontal,
  nps: BarChart3,
  rating: Star,
  picture_choice: Image,
  yes_no: ToggleLeft,
  statement: MessageSquare,
  redirect_url: ExternalLink,
};

/**
 * Fallback icon for unknown FieldType values (defensive: union extension without map update).
 * Consumers can use: `FIELD_ICONS[type] ?? FIELD_ICON_FALLBACK`.
 */
export const FIELD_ICON_FALLBACK: LucideIcon = Type;
